import React from 'react';
import { Box, BoxProps, FuseSelect, dataModelIcons } from '/src/components';
import { Loan, TLoanId } from '/src/lib/models';
import { DataModelType } from '/src/lib/types';

export type LoanSelectProps = {
  /**
   * Selected Loan ID
   */
  value: TLoanId;
  /**
   * Sets the currently selected Loan ID
   * @param value TLoanId
   * @returns void
   */
  setValue: (value: TLoanId) => void;
  /**
   * List of Loans to display in the dropdown
   */
  loans: Loan[];
  /**
   * Optional Box component props
   */
  boxProps?: BoxProps;
  /**
   * Show a label for this component
   */
  showLabel?: boolean;
  /**
   * Element ID
   */
  id?: string;
  /**
   * Element name
   */
  name?: string;
  /**
   * Element class
   */
  className?: string;
  /**
   * Whether this component is disabled
   */
  disabled?: boolean;
  /**
   * If true, shows error if value is empty
   */
  required?: boolean;
  /**
   * Error to display if `required` is set to true
   */
  error?: string;
  /**
   * Text to display if no value is set
   */
  placeholder?: string;
  /**
   * Label for screen readers
   */
  ariaLabel?: string;
  /**
   * Whether to enable the placeholder as a selectable option
   */
  enablePlaceholderOption?: boolean;
};

export const LoanSelect: React.FC<LoanSelectProps> = ({
  value,
  setValue,
  loans,
  boxProps,
  placeholder = 'Select Deal',
  ariaLabel = 'Select Deal',
  ...selectProps
}) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" gap="6px" {...boxProps}>
      <Box component="span">{dataModelIcons[DataModelType.Loan]}</Box>
      <FuseSelect
        value={value}
        updateValue={(value) => setValue(value)}
        placeholder={placeholder}
        ariaLabel={ariaLabel}
        options={loans.map((loan) => ({ label: loan.name, value: loan._id }))}
        {...selectProps}
      />
    </Box>
  );
};
